module.exports = __webpack_public_path__ + "static/media/gas-pump.aae84445.svg";